import React from "react";
import {MainCP}  from "../../../Components/proyecto-graficos/proyecto-graficosV2/MainCP"

const ViewProyectoGraficosV2: React.FC = () => <MainCP/>

export default ViewProyectoGraficosV2;